<template>
	<footer class="footer">
		<div class="container">
			© Todos os direitos reservados Mercobran
			 <br /><br />
		</div>
	</footer>
</template>

<script>
import mixins from "@/mixins/mixins";

export default {
	name: "LandPageFooter",

	mixins: [mixins],

	computed: {
		mensagemDireitosReservados() {
			return `© Todos os direitos reservados ${this.nomeParceiro}`;
		}
	},
};
</script>

<style scoped>
a {
	cursor: pointer;
}
.footer {
	text-align: center;
	padding: 15px 0;
	color: var(--grayColor);
	font-family: Cabin;
}
</style>
